  1<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Master Record Highlights
          </div>
        </template>
        <template #actions>
            <ul>
              <li class="p-narrow no-border">
                <div class="list-content">
                  <router-link
                    :to="{
                      name: 'PidMasterRecord',
                      query: {
                        retired: isRetired,
                      },
                    }"
                  >
                    <font-awesome-icon
                      :icon="['far', 'angle-double-right']"
                      size="2x"
                      title="View Details"
                    />
                  </router-link>
                </div>
              </li>
            </ul>
        </template>
      </es-header>
    </div>
    <div class="content" style="padding: 0">
      <es-form>
        <template #es-form-header style="margin: 0">
          <div class="header-container">
            <div class="header-elements">
              <font-awesome-icon :icon="['fas', 'user']"/>
            </div>
            <div class="header-elements">
              <h6 class="title">
                Person Information
              </h6>
            </div>
          </div>
        </template>
        <template #es-form>
          <div
            v-if="fieldEnabled('FIRST_NAME')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('FIRST_NAME') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ person.firstName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('MIDDLE_NAME')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('MIDDLE_NAME') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ person.middleName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('LAST_NAME')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('LAST_NAME') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ person.lastName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('PREVIOUS_LAST_NAME')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('PREVIOUS_LAST_NAME') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ person.previousLastName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('GENDER_CODE')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('GENDER_CODE') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ getDescriptionFromCode(person.genderCode,activeGenders) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('DATE_OF_BIRTH')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('DATE_OF_BIRTH') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <span v-if="person.dateOfBirth">
                      {{ displayDOBFormat(person.dateOfBirth) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('SOCIAL_SECURITY_NUMBER')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('SOCIAL_SECURITY_NUMBER') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field" v-if="hasModule('PRSID:PRPRF:SSN:VIEW')">
                  <div class="control">
                    {{ person.socialSecurityNumber }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('ETHNICITY_INDICATOR')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('ETHNICITY_INDICATOR') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ getDescriptionFromCode(person.ethnicityIndicator,activeEthnicities,'--') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('RACE_ETHNIC_CODE')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('RACE_ETHNIC_CODE') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{ getDescriptionFromCode(person.raceEthnicCode,activeRaces,'--') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="fieldEnabled('STATE_STUDENT_ID')"
            class="row"
          >
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">
                  {{ fieldLabel('STATE_STUDENT_ID') }}
                </label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    {{
                      formatStateID(person.stateStudentId ? person.stateStudentId : person.personId)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import DateUtils from '@/mixins/DateUtils';
import FieldLabels from '@/mixins/FieldLabels';
import LookupsUtils from '@/mixins/LookupsUtils';
import PermissionManager from '@/mixins/PermissionManager';
import StateIdUtils from '@/mixins/StateIdUtils';

library.add(
  faAngleDoubleRight,
  faUser,
);

export default {
  mixins: [
    DateUtils,
    FieldLabels,
    LookupsUtils,
    PermissionManager,
    StateIdUtils,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  props: {
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('lookups', [
      'activeEthnicities',
      'activeGenders',
      'activeRaces',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
      'getFieldLabelByPersonType',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadEthnicities',
      'loadGenders',
      'loadRaces',
    ]),
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.person.personType);
    },
    fieldLabel(code) {
      return this.getFieldLabelByPersonType(code, 'ASSIGN', this.person.personType);
    },
  },
};
</script>

<style lang="sass" scoped>

  .label
    width: 150px

  .control
    padding-left: 50px
  .row .field.is-horizontal
    display: flex
    flex-wrap: wrap
</style>
